import React from 'react';
import classNames from '../../utils/classNames';

import successSvg from './success.svg';

import './Icon.css';

const ownIcons = {
  success: successSvg
};

const Icon = ({ name, spaced, spin, pulse, className, alt='svg Icon', ...rest }) => {
  if (Object.keys(ownIcons).includes(name)) {
    return (
      <img
        {...rest}
        className={classNames(
          'Icon',
          'fa',
          `Icon__${name}`,
          spaced && 'Icon--spaced',
          spin && 'fa-spin',
          pulse && 'fa-pulse',
          className
        )}
        alt={alt}
        src={ownIcons[name]}
      />
    );
  }

  return (
    <span
      {...rest}
      className={classNames(
        'Icon',
        'fa',
        `fa-${name}`,
        spaced && 'Icon--spaced',
        spin && 'fa-spin',
        pulse && 'fa-pulse',
        className
      )}
    />
  );
};
Icon.defaultProps = {
  name: '',
  spaced: false,
  spin: false,
  pulse: false
};

export default Icon;
